/* eslint-disable react/no-array-index-key */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import {
    Checkbox,
    FormControlLabel,
    Box,
    FormControl,
    FormGroup,
    Grid2,
    Chip,
    Typography,
    Button,
    Collapse,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { Controller, useFormContext } from 'react-hook-form';
import { COLORS } from '../../../utils/Application_Constants';
import { ExpenseStatusChipStyles } from './ExpenseStatus.enum';

const styles = (theme) => ({
    drawer: {
        width: '28em',
        padding: '1em',
        position: 'initial',
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '&:focus': {
            backgroundColor: 'transparent',
        },
        '&:active': {
            backgroundColor: 'transparent',
        },
        borderRadius: '0',
    },
    content: {
        paddingLeft: '1em',
    },
    clear: {
        textDecoration: 'underline',
        paddingLeft: '1em',
    },
    chipRoot: {
        textAlign: 'center',
        width: '13em',

        [theme.breakpoints.up('lg')]: {
            minWidth: '100px',
        },
    },
    ...ExpenseStatusChipStyles,
    border: {
        borderBottom: '1px solid',
    },
    checkboxLabel: {
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '20px',
    },
    expenseTypeHeader: {
        borderBottom: `1px solid ${COLORS.LT_MIDNIGHTSTEEL}`,
        paddingBottom: '4px',
        marginBottom: '8px',
        marginTop: '10px',
    },
});

/**
 * Mutual-exclusion for checkbox options that declare `exclude`.
 * Selecting an item removes any values listed in that item's `exclude` array.
 * Used so Special Processing and Exclude Special Processing cannot both be applied.
 */
export const getNextCheckboxValues = (currentValues, selectedItem, selectedValue, isChecked) => {
    const values = currentValues ?? [];
    if (!isChecked) {
        return values.filter((item) => item !== selectedValue);
    }

    let nextValues = [...values, selectedValue];
    if (Array.isArray(selectedItem?.exclude) && selectedItem.exclude.length > 0) {
        nextValues = nextValues.filter((item) => !selectedItem.exclude.includes(item));
    }
    return nextValues;
};

const ExpenseFilterCheckbox = (props) => {
    const { classes, filterName, list, isExpenseType } = props;
    const { control, watch, setValue, getValues } = useFormContext();
    const watchedValue = watch(filterName);
    const [expanded, setExpanded] = useState(false);

    const renderStatusChip = (item) => {
        const name = item.UI;
        const status = item.value;
        return (
            <Chip
                label={name}
                className={classes[`chip${status}`]}
                classes={{ root: classes.chipRoot }}
                title={name}
            />
        );
    };

    const filterList = () => (
        <FormControl component="fieldset">
            <FormGroup>
                <Controller
                    name={filterName}
                    control={control}
                    defaultValue={[]}
                    render={({ field, onChange, value: values }) => {
                        let items = list;

                        if (filterName === 'Statuses') {
                            const colorOrder = [
                                COLORS.LT_SUNFLOWER25,
                                COLORS.LT_JOURNEY10,
                                COLORS.LT_PEPPER10,
                                COLORS.LT_EMERALD10,
                            ];

                            items = [...list].sort((a, b) => {
                                const styleA = ExpenseStatusChipStyles[`chip${a.value}`];
                                const styleB = ExpenseStatusChipStyles[`chip${b.value}`];
                                const bgColorA = styleA?.backgroundColor;
                                const bgColorB = styleB?.backgroundColor;
                                return colorOrder.indexOf(bgColorA) - colorOrder.indexOf(bgColorB);
                            });
                        }

                        return items.map((item) => {
                            let label = item.label ?? item;
                            let value = item.value ?? item;
                            const selectedValues = values ?? [];

                            if (filterName === 'Statuses') {
                                label = renderStatusChip(item);
                                value = item.UI;
                            }

                            return (
                                <FormControlLabel
                                    key={value}
                                    control={
                                        <Checkbox
                                            checked={selectedValues.includes(value)}
                                            onChange={(e) =>
                                                onChange(
                                                    getNextCheckboxValues(
                                                        selectedValues,
                                                        item,
                                                        value,
                                                        e.target.checked
                                                    )
                                                )
                                            }
                                            {...field}
                                            value={value}
                                            color="primary"
                                        />
                                    }
                                    classes={{ label: classes.checkboxLabel }}
                                    label={label}
                                />
                            );
                        });
                    }}
                />
            </FormGroup>
        </FormControl>
    );

    const expenseTypeList = () => (
        <FormControl component="fieldset">
            <FormGroup>
                <Controller
                    name={filterName}
                    control={control}
                    defaultValue={[]}
                    render={({ field, onChange, value }) =>
                        list?.map((category, catIndex) => {
                            const categoryName = category.category;
                            const type = category.types;
                            return (
                                <Grid2 key={`category-${catIndex}-${categoryName}`}>
                                    <Typography className={classes.expenseTypeHeader}>
                                        {categoryName}
                                    </Typography>
                                    {type.map((typeName, typeIndex) => (
                                        <React.Fragment
                                            key={`type-${catIndex}-${typeName.description}-${typeIndex}`}
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={value.includes(
                                                            typeName.description
                                                        )}
                                                        onChange={(e) =>
                                                            onChange(
                                                                e.target.checked
                                                                    ? [
                                                                          ...value,
                                                                          typeName.description,
                                                                      ]
                                                                    : value.filter(
                                                                          (s) =>
                                                                              s !==
                                                                              typeName.description
                                                                      )
                                                            )
                                                        }
                                                        {...field}
                                                        value={typeName.description}
                                                        color="primary"
                                                    />
                                                }
                                                classes={{
                                                    label: classes.checkboxLabel,
                                                }}
                                                label={typeName.description}
                                            />
                                            <Box component="div" m={1} />
                                        </React.Fragment>
                                    ))}
                                </Grid2>
                            );
                        })
                    }
                />
            </FormGroup>
        </FormControl>
    );

    const renderAccordion = () => (
        <>
            <Button
                className={classes.drawer}
                style={
                    !expanded
                        ? { borderBottom: `1px solid ${COLORS.LT_MIDNIGHTSTEEL}` }
                        : { borderBottom: 'none' }
                }
                disableRipple
                onClick={() => setExpanded(!expanded)}
                aria-expanded={expanded}
                aria-controls="panel1-content"
                endIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            >
                {expanded ? (
                    <Grid2 container flex={1} spacing={1}>
                        <Grid2 item>
                            <Typography>
                                {filterName} ({watchedValue?.length ? watchedValue?.length : 0})
                            </Typography>
                        </Grid2>
                        <Grid2 item>
                            <Typography
                                variant="body2"
                                className={classes.clear}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    setValue(filterName, []);
                                }}
                            >
                                Clear
                            </Typography>
                        </Grid2>
                    </Grid2>
                ) : (
                    <Grid2 container flex={1} spacing={1}>
                        <Grid2 item>
                            <Typography>
                                {filterName} ({watchedValue?.length ? watchedValue?.length : 0})
                            </Typography>
                        </Grid2>
                    </Grid2>
                )}
            </Button>
            <Collapse in={expanded} className={classes.content}>
                {!isExpenseType ? filterList() : expenseTypeList()}
            </Collapse>
        </>
    );

    return <>{renderAccordion()}</>;
};

export default withStyles(styles)(ExpenseFilterCheckbox);
